import { CSVExport } from '../CSVExport';

export class ExportView {

    constructor(store) {
        this.store = store;
        this.caller = null;
    }

    render(caller) {
        this.caller = caller;
        const container = document.createElement("div");
        container.className = "width-100 height-100";
        const label = document.createElement("div");
            label.className = "section-title";
          label.textContent = "CSV letöltés";
        container.appendChild(label);
        const wrapper = document.createElement("div");
        wrapper.className = "csvexport-grid";
         let inventoryAvatar = this.createAvatar('/assets/others.png' , 'Eszközök')
        wrapper.appendChild(inventoryAvatar);
        let userAvatar = this.createAvatar('/assets/newuser.png' , 'Kollégák')
        wrapper.appendChild(userAvatar);
        let cityAvatar = this.createAvatar('/assets/pin.png' , 'Városok')
        wrapper.appendChild(cityAvatar);
        let searchAvatar = this.createAvatar('/assets/magnifier.png' , 'A keresés eredménye')
        wrapper.appendChild(searchAvatar);
        let cityuserAvatar = this.createAvatar('/assets/cityusers.png' , 'Látogatott települések')
        wrapper.appendChild(cityuserAvatar);
        let logAvatar = this.createAvatar('/assets/log.png' , 'Logok')
        wrapper.appendChild(logAvatar);
        container.appendChild(wrapper)
        return container
    }

    createAvatar(imageUrl, text) {
        const avatatrwrapper = document.createElement("div");
        avatatrwrapper.className="csvexport-avatar";
        const img=document.createElement("img");
        img.src=imageUrl;
        img.className="csvexport-avatarpic";
        img.id = text
        img.style.objectFit = "contain";
        const label = document.createElement("div");
        label.textContent = text;
        label.className = this.store.config.isSmall ? "font-12 color-50 weight-500" : "font-20 color-50 weight-500";
        avatatrwrapper.appendChild(img);
        avatatrwrapper.appendChild(label);
        this.bindItemEvents(img);
        return avatatrwrapper
    }

    bindItemEvents(item) {
        item.addEventListener("click", async e => {
            e.stopPropagation();
            switch (item.id) {
                case "Városok": const cities = await this.store.datas.export('CITIES');
                    CSVExport(this.store.database.exportdatas, 'Városok.csv');
                    break;
                case "Eszközök": const inventory = await this.store.datas.export('INVENTORY');
                    CSVExport(this.store.database.exportdatas, 'Eszközök.csv');
                    break;
                case "Kollégák": const users = await this.store.datas.export('USERS');
                    CSVExport(this.store.database.exportdatas, 'Kollégák.csv');
                    break;
                case "Látogatott települések": const cityusers = await this.store.datas.export('CITYUSERS');
                    CSVExport(this.store.database.exportdatas, 'Látogatott települések.csv');
                    break;
                case "A keresés eredménye":
                    if (this.store.database.searchResults === undefined) {
                        console.log('SEARCHNULL');
                    } else {
                        if (this.store.database.searchResults.inventory.length !== 0) {
                            const inventoryExport = await this.store.datas.createExportData(this.store.database.searchResults.inventory);
                            CSVExport(inventoryExport, 'A keresés eredménye - eszközök.csv');
                        }
                        if (this.store.database.searchResults.users.length !== 0) {
                            const usersExport = await this.store.datas.createExportData(this.store.database.searchResults.users);
                            CSVExport(usersExport, 'A keresés eredménye - kollégák.csv');
                        }
                    }
                break;
                case "Logok": const logs = await this.store.datas.export('LOGS');
                    CSVExport(this.store.database.exportdatas, 'Logok.csv');
                    break;
            }
            

            
        });
    }

    getData(form) {
        const result = {};
        Object.entries(this.data).forEach(([key, value]) => {
            const input = form.elements[key];
            result[key] = typeof value === "number" ? Number(input.value) : input.value;});
        return result;
    }

    

}